import { render, staticRenderFns } from "./ClientProductDetail.vue?vue&type=template&id=c9edf2fc&scoped=true&"
import script from "./ClientProductDetail.vue?vue&type=script&lang=js&"
export * from "./ClientProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientProductDetail.vue?vue&type=style&index=0&id=c9edf2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9edf2fc",
  null
  
)

export default component.exports